module.exports = __webpack_public_path__ + "static/media/Comportamiento_Fraudulento_Candidato.2612dd74.docx";